export const DEFAULT_CONFIG = {
  REQUEST_TIMEOUT: 90000,
  STORAGE_DRIVE: 's3',

  CURRENCY: 'SGD ',
  CURRENCY_USD: '$ ',

  UPLOAD_FOLDER_LOCAL: 'cimb-sme-files-storage-local',

  // Max - Max Length
  MAX_VALUE: {
    DECIMAL: 99999999.99,
    SMALL_DECIMAL: 99999.99,
    INTEGER: 1000,
  },

  MAX_LENGTH: {
    TEXT_FIELD: 200,
    TEXT_AREA: 500,
    NAME_LENGTH: 120,
  },

  TIME_OUT_IN_SECONDS: 1800,

  // Breakpoint
  BREAKPOINTS: {
    XX_SMALL: '(max-width: 424.98px)',
    X_SMALL: '(min-width: 425px) and (max-width: 599.98px)',
    SMALL: '(min-width: 600px) and (max-width: 767.98px)',
    MEDIUM: '(min-width: 768px) and (max-width: 1023.98px)',
    LARGE: '(min-width: 1024px) and (max-width: 1279.98px)',
    X_LARGE: '(min-width: 1280px) and (max-width: 1439.98px)',
    XX_LARGE: '(min-width: 1440px)',
  },
} as const;
